import { useCallback, useEffect, useImperativeHandle, useState } from 'react';
import { useEventListener, useIntersectionObserver } from 'usehooks-ts';

export const useTextSize = (textRef: React.RefObject<HTMLHeadingElement>) => {
  const [becameVisible, setBecameVisible] = useState(false);
  const [size, setSize] = useState<{ width: number; height: number } | null>(null);

  const { ref, entry } = useIntersectionObserver({
    threshold: 0.5,
  });

  useImperativeHandle(
    ref,
    () => {
      return textRef.current!;
    },
    [textRef]
  );

  const measureTextHeight = useCallback(() => {
    if (textRef.current) {
      const { height, width } = textRef.current.getBoundingClientRect();
      setSize({ height, width });
    }
  }, [textRef]);

  useEffect(() => {
    measureTextHeight();
  }, [textRef.current?.offsetHeight, textRef.current?.offsetWidth, measureTextHeight]);

  useEffect(() => {
    measureTextHeight();
  }, [measureTextHeight]);

  useEventListener('resize', measureTextHeight);

  useEffect(() => {
    if (entry?.isIntersecting) {
      setBecameVisible(true);
    }
  }, [entry]);

  return { becameVisible, height: size?.height, width: size?.width, ref };
};
